// extracted by mini-css-extract-plugin
export var errorBanner = "_k8-2";
export var scroller = "_k8-0";
export var thinking = "_k8-1";
export var visuallyHidden = "_k8-3";